<template>
  <div class="finance-transaction-modal">
    <c-sidesheet
      id="finance-transaction-modal"
      :active="localActive"
      @close="localActive = false"
    >

      <div class="modal-frame">
        <div class="modal-wrapper">
          <shadow-scroll-container ref="track" class="modal-track" :with-top-scroller="true">

          <div class="finance-transaction-modal-title">
        {{ type === "deposit" ? "Операции с депозитом" : "Внесение/снятие средств" }}
      </div>
      <c-switcher
        v-model="switcherLocal"
        class="h-switcher finance-transaction-modal-switcher"
        :class="{'deposit': switcherLocal === 'make'}"
        type="group"
        :items="[
          { label: 'Внесение', value: 'make' },
          { label: 'Снятие', value: 'takeoff' },
        ]"
      />
      <div class="row">
        <div class="col col-xl-2 col-md-3 col-xs-12">
          <c-input
            v-if="type === 'deposit'"
            v-model="deposit.summLocal"
            class="finance-transaction-modal-deposit-row-input"
            :input-text-condition="deposit.summLocalErrorMessage"
            placeholder="0"
            label="Сумма, ฿"
            type="price-number"
            :required-mark="true"
          />
          <c-input
            v-else
            v-model="accountableTransaction.summLocal"
            class="finance-transaction-modal-deposit-row-input"
            :input-text-condition="accountableTransaction.summLocalErrorMessage"
            placeholder="0"
            label="Сумма, ฿"
            type="price-number"
            :required-mark="true"
          />
        </div>
        <div class="col col-xl-2 col-md-3 col-xs-12">
          <c-input
            v-show="type === 'deposit'"
            ref="dateInput1"
            v-model="deposit.dateEntryLocal"
            class="finance-transaction-modal-deposit-row-date"
            :label="switcherLocal === 'make' ? 'Дата внесения' : 'Дата снятия'"
            type="date"
            :required="deposit.submitAttempt && deposit.dateEntryLocalErrorMessage"
            :required-message="deposit.submitAttempt && deposit.dateEntryLocalErrorMessage"
            :required-mark="true"
            format="DD.MM.YYYY, dddd"
            icon="calendar"
            placeholder="00.00.0000"
            :editable="true"
            :icon-right="true"
            @invalidDate="sendErrorDateMessageDeposit"
            :clearable="true"
          />
          <c-input
            v-show="type === 'accountable-transaction'"
            ref="dateInput2"
            v-model="accountableTransaction.dateEntryLocal"
            class="finance-transaction-modal-deposit-row-date"
            :label="switcherLocal === 'make' ? 'Дата внесения' : 'Дата снятия'"
            type="date"
            :required="accountableTransaction.submitAttempt && accountableTransaction.dateEntryLocalErrorMessage"
            :required-message="accountableTransaction.submitAttempt && accountableTransaction.dateEntryLocalErrorMessage"
            :required-mark="true"
            format="DD.MM.YYYY, dddd"
            icon="calendar"
            placeholder="00.00.0000"
            :editable="true"
            :icon-right="true"
            @invalidDate="sendErrorDateMessageAccountableTransaction"
            :clearable="true"
          />
        </div>
      </div>
      <div class="row">
        <div class="col col-xl-6 col-md-10 col-xs-12">
          <c-select-2
            v-if="type === 'deposit'"
            v-model="deposit.whoContributedLocal"
            class="finance-transaction-modal-deposit-row-select"
            :items="deposit.whoContributedItems"
            :required="deposit.whoContributedLocalErrorMessage"
            :required-condition="deposit.whoContributedLocalErrorMessage.length > 0"
            :label="switcherLocal === 'make' ? 'Кто внёс' : 'Кто снял'"
            type="select"
            :searchable="true"
            placeholder="Выберите пользователя"
            :clearable="true"
            :required-mark="true"
          />
          <c-select-2
            v-else
            v-model="accountableTransaction.whoContributedLocal"
            class="finance-transaction-modal-deposit-row-select"
            :items="deposit.whoContributedItems"
            :floating-label="switcherLocal === 'make' ? 'Кто внёс' : 'Кто снял'"
            type="select"
            :searchable="true"
            :clearable="true"
            :required-mark="true"
          />
        </div>
      </div>
      <div class="row">
        <div class="col col-xl-6 col-md-10 col-xs-12">
          <c-switcher
            v-if="type === 'deposit'"
            v-model="deposit.switcherLocal"
            class="finance-transaction-modal-deposit-switcher"
            :label="depositSwitcherLabel"
          />
          <c-switcher
            v-else
            v-model="accountableTransaction.switcherLocal"
            class="finance-transaction-modal-deposit-switcher"
            :label="accountableTransactionSwitcherLabel"
          />
        </div>
      </div>
      <div v-if="deposit.switcherLocal" class="row">
        <div class="col col-xl-3 col-md-5 col-xs-12">
          <c-select-2
            v-model="deposit.selectedFilial"
            type="select"
            floating-label="Филиал"
            :clearable="true"
            :searchable="true"
            :items="this.filials.allFilials"
            :useCustomColors="true"
            :required="this.deposit.selectedFilialErrorMessage"
            :required-message="this.deposit.selectedFilialErrorMessage"
            :required-mark="true"
          />
        </div>
        <div class="col col-xl-3 col-md-5 col-xs-12">
          <c-select-2
            v-model="deposit.selectedPost"
            class="modal-frame__filial"
            type="select"
            floating-label="Должность"
            :clearable="true"
            :searchable="true"
            :items="this.posts.allPosts"
            :useCustomColors="true"
            :required="this.deposit.selectedPostErrorMessage"
            :required-message="this.deposit.selectedPostErrorMessage"
            :required-mark="true"
          />
        </div>
      </div>
      <div v-if="accountableTransaction.switcherLocal" class="row">
        <div class="col col-xl-3 col-md-5 col-xs-12">
          <c-select-2
            v-model="accountableTransaction.selectedFilial"
            type="select"
            floating-label="Филиал"
            :clearable="true"
            :searchable="true"
            :items="this.filials.allFilials"
            :useCustomColors="true"
            :required="this.accountableTransaction.selectedFilialErrorMessage"
            :required-message="this.accountableTransaction.selectedFilialErrorMessage"
            :required-mark="true"
          />
        </div>
        <div class="col col-xl-3 col-md-5 col-xs-12">
          <c-select-2
            v-model="accountableTransaction.selectedPost"
            class="modal-frame__filial"
            type="select"
            floating-label="Должность"
            :clearable="true"
            :searchable="true"
            :items="this.posts.allPosts"
            :useCustomColors="true"
            :required="this.accountableTransaction.selectedPostErrorMessage"
            :required-message="this.accountableTransaction.selectedPostErrorMessage"
            :required-mark="true"
          />
        </div>
      </div>
      <div v-if="deposit.switcherLocal" class="row">
        <div class="col col-xl-6 col-md-10 col-xs-12">
          <c-select-2
            v-model="deposit.selectedCompany"
            class="modal-frame__transaction-type"
            type="select"
            floating-label="Юр. лицо"
            :clearable="true"
            :searchable="true"
            :items="companies.items"
            :required="this.deposit.selectedCompanyErrorMessage"
            :required-message="this.deposit.selectedCompanyErrorMessage"
            :required-mark="true"
          />
        </div>
      </div>
      <div v-if="accountableTransaction.switcherLocal" class="row">
        <div class="col col-xl-6 col-md-10 col-xs-12">
          <c-select-2
            v-model="accountableTransaction.selectedCompany"
            class="modal-frame__transaction-type"
            type="select"
            floating-label="Юр. лицо"
            :clearable="true"
            :searchable="true"
            :items="companies.items"
            :required="this.accountableTransaction.selectedCompanyErrorMessage"
            :required-message="this.accountableTransaction.selectedCompanyErrorMessage"
            :required-mark="true"
          />
        </div>
      </div>
      <div v-if="switcherLocal=='make'  && false" class="row">
        <div class="col col-xl-6 col-md-10 col-xs-12">
          <c-select-2
            v-model="accountableTransaction.selectedMoneySource"
            type="select"
            floating-label="Источник д/с"
            :clearable="true"
            :searchable="true"
            :items="moneySourcesList.items"
          />
        </div>
      </div>
      <div class="row">
        <div class="col col-xl-6 col-md-10 col-xs-12">
          <c-input
            v-if="type === 'deposit'"
            ref="comment"
            type="textarea"
            v-model="deposit.commentLocal"
            class="finance-transaction-modal-deposit-comment"
            floating-label="Комментарий"
            :clearable="true"
            max-length="255"
          />
          <c-input
            v-show="type === 'accountable-transaction'"
            ref="textarea2"
            type="textarea"
            v-model="accountableTransaction.commentLocal"
            class="finance-transaction-modal-deposit-comment"
            floating-label="Комментарий"
            :clearable="true"
            max-length="255"
          />
        </div>
      </div>

      <div v-if="type === 'personal_account'" class="finance-transaction-modal-personal-account">
        <div class="finance-transaction-modal-personal-account-row">
          <c-input
            v-model="personalAccount.summLocal"
            class="finance-transaction-modal-personal-account-row-input"
            placeholder="0"
            label="Сумма, ฿"
            :input-text-condition="personalAccount.summLocalErrorMessage"
            type="price-number"
          />
          <c-input
            v-model="personalAccount.whoContributedLocal"
            class="finance-transaction-modal-personal-account-row-select"
            :class="{
              'finance-transaction-modal-personal-account-row-select-mt-50':
                personalAccount.dateEntryLocalErrorMessage.length > 0 ||
                personalAccount.summLocalErrorMessage.length > 0,
            }"
            :items="personalAccount.whoContributedItems"
            type="select"
            :required="personalAccount.whoContributedLocalErrorMessage"
            :required-condition="personalAccount.whoContributedLocalErrorMessage.length > 0"
            :searchable="true"
            :label="switcherLocal === 'make' ? 'Кто внёс' : 'Кто снял'"
            placeholder="Выберите пользователя"
          />
        </div>
        <c-input-old
          v-model="personalAccount.reasonLocal"
          class="finance-transaction-modal-personal-account-reason"
          :class="{
            'finance-transaction-modal-personal-account-reason-required':
              personalAccount.reasonLocalErrorMessage.length > 0,
            'finance-transaction-modal-personal-account-reason-mt-50':
              personalAccount.dateEntryLocalErrorMessage.length > 0 || personalAccount.summLocalErrorMessage.length > 0,
          }"
          :items="reasonsForSelect"
          :required="personalAccount.reasonLocalErrorMessage"
          :required-condition="personalAccount.reasonLocalErrorMessage.length > 0"
          :with-special-value="true"
          type="select"
          :searchable="true"
          floating-label="Выберите причину"
        />
        <transition name="fade">
          <c-input-old
            v-if="personalAccount.reasonLocal !== null && personalAccount.reasonLocal.specialValue"
            v-model="personalAccount.newReasonTextLocal"
            class="finance-transaction-modal-personal-account-reason-text"
            :class="{
              'finance-transaction-modal-personal-account-reason-text-required':
                personalAccount.newReasonTextLocalErrorMessage.length > 0,
            }"
            :required="personalAccount.newReasonTextLocalErrorMessage"
            floating-label="Введите причину"
          />
        </transition>
        <c-input
          type="textarea"
          v-model="personalAccount.commentLocal"
          class="finance-transaction-modal-personal-account-comment"
          floating-label="Комментарий"
          :clearable="true"
          max-length="255"
        />
        <div class="finance-transaction-modal-personal-account-buttons">
          <c-button
            class="finance-transaction-modal-personal-account-buttons-cancel"
            label="Отменить"
            @click="localActive = false"
          />
          <c-button
            class="finance-transaction-modal-personal-account-buttons-make"
            label="Сохранить"
            color="primary"
            @click="submitPersonalAccount"
          />
        </div>
      </div>
      <div v-if="type === 'deposit'" class="finance-transaction-modal-deposit">
        <div
          class="finance-transaction-modal-deposit-row"
          :class="{
            'finance-transaction-modal-deposit-row-required':
              deposit.summLocalErrorMessage.length > 0 ||
              deposit.dateEntryLocalErrorMessage.length > 0 ||
              deposit.whoContributedLocalErrorMessage.length > 0,
          }"
        >
        </div>


        <div v-show="localActive" class="finance-transaction-modal-deposit-buttons">
          <c-button
            class="finance-transaction-modal-deposit-buttons-cancel"
            label="Отменить"
            @click="localActive = false"
          />
          <c-button
            class="finance-transaction-modal-deposit-buttons-make"
            label="Сохранить"
            color="primary"
            @click="submitDeposit"
          />
        </div>
      </div>
      <div v-if="type === 'accountable-transaction'" class="finance-transaction-modal-deposit">
        <div v-show="localActive" class="finance-transaction-modal-deposit-buttons">
          <c-button
            class="finance-transaction-modal-deposit-buttons-cancel"
            label="Отменить"
            @click="localActive = false"
          />
          <c-button
            class="finance-transaction-modal-deposit-buttons-make"
            label="Сохранить"
            color="primary"
            @click="submitAccountableTransaction"
          />
        </div>
      </div>
          </shadow-scroll-container>
        </div>
      </div>
    </c-sidesheet>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Button from "@/components/controls2/Button";
import Input from "@/components/controls2/Input";
import InputOld from "@/components/controls/input-old";
import Switcher from "@/components/controls2/Switcher";
import Textarea from "@/components/textarea";
import { privateTransactionsTypes } from "@/constants/privateTransactionsTypes";
import CSidesheet from "@/components/sidesheet";
import Select2 from "@/components/controls2/Select";
import Loader from "@/components/loader";
import ShadowScrollContainer from "@/components/shadow-scroll-container";

export default {
  name: "finance-transaction-modal",
  components: {
    "c-button": Button,
    "c-input": Input,
    "c-input-old": InputOld,
    "c-switcher": Switcher,
    "c-textarea": Textarea,
    CSidesheet,
    "c-select-2": Select2,
    ShadowScrollContainer,
  },
  props: ["active", "type", "currentUserPersonalAmount"],
  data() {
    return {
      localActive: false,
      switcherLocal: "make",
      workersLocal: [],
      worker: {
        id: 0,
        filial: '',
        filial_id: 0,
        postCodes: [],
      },
      filials: {
        allFilials: []
      },
      posts: {
        allPosts: []
      },
      companies: {
        items: [],
      },
      personalAccount: {
        summLocal: "",
        summLocalErrorMessage: "",
        dateEntryLocal: "",
        dateEntryLocalErrorMessage: "",
        whoContributedLocal: null,
        whoContributedLocalErrorMessage: "",
        whoContributedItems: [],
        reasonLocal: null,
        reasonLocalErrorMessage: "",
        reasonItems: [],
        newReasonTextLocal: "",
        newReasonTextLocalErrorMessage: "",
        commentLocal: "",
        submitAttempt: false,
      },
      deposit: {
        summLocal: "",
        summLocalErrorMessage: "",
        dateEntryLocal: "",
        dateEntryLocalErrorMessage: "",
        whoContributedLocal: null,
        whoContributedLocalErrorMessage: "",
        whoContributedItems: [],
        switcherLocal: false,
        commentLocal: "",
        submitAttempt: false,
        selectedFilial: "",
        selectedFilialErrorMessage: "",
        selectedPost: "",
        selectedPostErrorMessage: "",
        selectedCompany: "",
        selectedCompanyErrorMessage: "",
      },
      accountableTransaction: {
        summLocal: "",
        summLocalErrorMessage: "",
        dateEntryLocal: "",
        dateEntryLocalErrorMessage: "",
        whoContributedLocal: null,
        whoContributedLocalErrorMessage: "",
        whoContributedItems: [],
        switcherLocal: false,
        commentLocal: "",
        submitAttempt: false,
        selectedFilial: "",
        selectedFilialErrorMessage: "",
        selectedPost: "",
        selectedPostErrorMessage: "",
        selectedMoneySource: "",
        selectedCompany: "",
        selectedCompanyErrorMessage: ""
      },
      moneySourcesList: {
        selectedMoneySource: '',
        items: [],
        defaultItems: [],
      },
    };
  },

  computed: {
    ...mapState({
      companiesFromStore: (state) => state.personalEmployee.transactions.companies,
      employeeInfo: (state) => state.personalEmployee.transactions.employeeInfo,
      workersListFromStore: (state) => state.personalEmployee.transactions.workersList,
    }),

    depositSwitcherLabel() {
      return `${this.switcherLocal === "make" ? "С личного счета" : "На личный счёт"} (баланс <b>${this.formatAmount(this.currentUserPersonalAmount)}฿</b>)`;
      // return `${this.switcherLocal === "make" ? "С личного счета" : "На личный счёт"}`;
    },
    accountableTransactionSwitcherLabel() {
      return `${this.switcherLocal === "make" ? "На личный счёт" : "С личного счета" } (баланс <b>${this.formatAmount(this.currentUserPersonalAmount)}฿</b>)`;
      // return `${this.switcherLocal === "make" ? "С личного счета" : "На личный счёт"}`;
    },
    currentUserBalance() {
      // if (!this.deposit.switcherLocal) {
      //   return this.currentUserPersonalAmount;
      // }

      // if (this.switcherLocal === "make") {
      //   return this.currentUserPersonalAmount - +this.deposit.summLocal;
      // }

      // return this.currentUserPersonalAmount + +this.deposit.summLocal;
      // return this.currentUserPersonalAmount;
    },
    reasonsForSelect() {
      if (this.switcherLocal === "make") {
        return this.filterReasonItemsByType(privateTransactionsTypes.deposit);
      }
      return this.filterReasonItemsByType(privateTransactionsTypes.withdraw);
    },
  },

  watch: {
    companiesFromStore() {
      this.formatCompanies()
    },

    "localActive": function (value) {
      if (!value) {
        setTimeout(() => {
          this.reset();
        }, 300);
        this.$emit("close");
      }
    },
    "active": function (value) {
      if (!value) {
        setTimeout(() => {
          this.reset();
        }, 300);
      }
      this.localActive = value;
    },

    "type": function () {
      this.reset();
    },

    "switcherLocal": function () {
      this.reset();
      this.$nextTick(() => {
        if (this.$refs.dateInput) this.$refs.dateInput.setCurrentDateInputTypeDate();
      });
    },

    "personalAccount.summLocal": function (value) {
      if (this.personalAccount.submitAttempt) {
        if (value.length === 0) {
          this.personalAccount.summLocalErrorMessage = "Обязательное поле";
        } else if (Number(value) === 0) {
          this.personalAccount.summLocalErrorMessage = "Введите сумму больше нуля"
        } else {
          this.personalAccount.summLocalErrorMessage = "";
        }
      }
    },

    "personalAccount.dateEntryLocal": function (value) {
      if (this.personalAccount.submitAttempt) {
        if (value.length === 0) {
          this.personalAccount.dateEntryLocalErrorMessage = "Обязательное поле";
        } else if (value.length < 10) {
          // this.personalAccount.dateEntryLocalErrorMessage = "Укажите корректное значение";
        } else {
          this.personalAccount.dateEntryLocalErrorMessage = "";
        }
      }
    },

    "personalAccount.whoContributedLocal": function (value) {
      if (this.personalAccount.submitAttempt) {
        if (value === null) {
          this.personalAccount.whoContributedLocalErrorMessage = "Обязательное поле";
        } else {
          this.personalAccount.whoContributedLocalErrorMessage = "";
        }
      }
    },

    "accountableTransaction.selectedFilial": function (value) {
      if (this.accountableTransaction.submitAttempt) {
        if (!value) {
          this.accountableTransaction.selectedFilialErrorMessage = "Обязательное поле";
        } else {
          this.accountableTransaction.selectedFilialErrorMessage = "";
        }
      }
    },

    "accountableTransaction.selectedPost": function (value) {
      if (this.accountableTransaction.submitAttempt) {
        if (!value) {
          this.accountableTransaction.selectedPostErrorMessage = "Обязательное поле";
        } else {
          this.accountableTransaction.selectedPostErrorMessage = "";
        }
      }
    },

    "accountableTransaction.selectedCompany": function (value) {
      if (this.accountableTransaction.submitAttempt) {
        if (!value) {
          this.accountableTransaction.selectedCompanyErrorMessage = "Обязательное поле";
        } else {
          this.accountableTransaction.selectedCompanyErrorMessage = "";
        }
      }
    },


    "personalAccount.reasonLocal": function (value) {
      if (this.personalAccount.submitAttempt) {
        if (value === null) {
          this.personalAccount.reasonLocalErrorMessage = "Обязательное поле";
        } else {
          this.personalAccount.reasonLocalErrorMessage = "";
        }
      }
    },

    "personalAccount.newReasonTextLocal": function (value) {
      if (this.personalAccount.submitAttempt) {
        if (value === undefined || value === null || value.length === 0) {
          this.personalAccount.newReasonTextLocalErrorMessage = "Обязательный параметр";
        } else {
          this.personalAccount.newReasonTextLocalErrorMessage = "";
        }
      }
    },

    "deposit.summLocal": function (value) {
      if (this.deposit.submitAttempt) {
        if (value.length === 0) {
          this.deposit.summLocalErrorMessage = "Обязательное поле";
        } else if (Number(value) === 0) {
          this.deposit.summLocalErrorMessage = "Введите сумму больше нуля"
        } else {
          this.deposit.summLocalErrorMessage = "";
        }
      }
    },

    "accountableTransaction.summLocal": function (value) {
      if (this.accountableTransaction.submitAttempt) {
        if (value.length === 0) {
          this.accountableTransaction.summLocalErrorMessage = "Обязательное поле";
        } else if (Number(value) === 0) {
          this.accountableTransaction.summLocalErrorMessage = "Введите сумму больше нуля"
        } else {
          this.accountableTransaction.summLocalErrorMessage = "";
        }
      }
    },

    "deposit.dateEntryLocal": function (value) {
      if (this.deposit.submitAttempt) {
        if (value.length === 0) {
          this.deposit.dateEntryLocalErrorMessage = "Обязательное поле";
        } else if (value.length < 10) {
          // this.personalAccount.dateEntryLocalErrorMessage = "Укажите корректное значение";
        } else {
          // this.deposit.dateEntryLocalErrorMessage = "";
        }
      }
    },

    "accountableTransaction.dateEntryLocal": function (value) {
      if (this.accountableTransaction.submitAttempt) {
        if (value.length === 0) {
          this.accountableTransaction.dateEntryLocalErrorMessage = "Обязательное поле";
        } else if (value.length < 10) {
          // this.personalAccount.dateEntryLocalErrorMessage = "Укажите корректное значение";
        } else {
          // this.accountableTransaction.dateEntryLocalErrorMessage = "";
        }
      }
    },

    "deposit.whoContributedLocal": function (value) {
      if (this.deposit.submitAttempt) {
        if (value === null) {
          this.deposit.whoContributedLocalErrorMessage = "Обязательное поле";
        } else {
          this.deposit.whoContributedLocalErrorMessage = "";
        }
      }
    },
  },

  methods: {
    formatCompanies() {
      this.companies.items = [];

      Object.entries(this.companiesFromStore).forEach(([key, value]) => {
        this.companies.items.push({
          value: key,
          label: value
        })
      });

      if (this.employeeInfo.company_id) {
        let employeeCompany = this.companies.items.find(company => Number(company.value) === this.employeeInfo.company_id)
        this.companies.items = this.companies.items.filter(company => Number(company.value) !== this.employeeInfo.company_id)
        this.companies.items.unshift({
          value: employeeCompany.value,
          label: employeeCompany.label,
          formatLabel: 
            `<div style='font-weight: 500; position: relative;'>
              ${employeeCompany.label}
              <span style="position: absolute;bottom: -8px;width: 100%;height: 1px;background: #DFE4EF;left: 0;"></span>
            </div>`,
        })
        this.deposit.selectedCompany = this.companies.items[0]
        this.accountableTransaction.selectedCompany = this.companies.items[0]
      } else if (this.employeeInfo.filial && this.employeeInfo.filial.company_id) {
        let filialCompany = this.companies.items.find(company => Number(company.value) === this.employeeInfo.filial.company_id)
        if (filialCompany) {
          this.companies.items = this.companies.items.filter(company => Number(company.value) !== this.employeeInfo.filial.company_id)
          this.companies.items.unshift({
            value: filialCompany.value,
            label: filialCompany.label,
            formatLabel:
              `<div style='font-weight: 500; position: relative;'>
              ${filialCompany.label}
              <span style="position: absolute;bottom: -8px;width: 100%;height: 1px;background: #DFE4EF;left: 0;"></span>
            </div>`,
          })
        }
        this.deposit.selectedCompany = this.companies.items[0]
        this.accountableTransaction.selectedCompany = this.companies.items[0]
      }
    },

    filterReasonItemsByType(typeId) {
      const items = this.personalAccount.reasonItems
        .filter((item) => item.type === typeId || item.type === privateTransactionsTypes.common)
        .sort((a, b) => b.sort - a.sort)
        .map((item) => ({ label: item.title, value: item.id }));

      items.unshift({ value: -1, label: "Указать свою причину", specialValue: true });

      return items;
    },
    sendErrorDateMessageAccountableTransaction(message) {
      this.accountableTransaction.dateEntryLocalErrorMessage = message;
    },
    sendErrorDateMessageDeposit(message) {
      this.deposit.dateEntryLocalErrorMessage = message;
    },

    async open() {
      
      // this.$nextTick(() => {
      //   if (this.$refs.dateInput) this.$refs.dateInput.setCurrentDateInputTypeDate();
      // });

      this.accountableTransaction.commentLocal = "";

      await this.$store.dispatch("personalEmployee/transactions/fetchEmployeeInfo", this.$route.params.id);

      await this.$store.dispatch("personalEmployee/transactions/fetchCompanies");

      await this.$store.dispatch("personalEmployee/transactions/fetchMoneySourcesList").then(res => {
        this.moneySourcesList.defaultItems = res.map(moneySource => ({
          value: moneySource.id,
          label: moneySource.name
        }))

        this.moneySourcesList.items = this.moneySourcesList.defaultItems
      })

      await this.$store.dispatch("personalEmployee/transactions/fetchFilialsList").then(data => {
        this.filials.allFilials = data
          .sort((a, b) => b.sort - a.sort)
          .map((filial) => ({
            value: filial.id,
            label: filial.name,
          }))
      })

      await this.$store.dispatch("personalEmployee/getUserInfo", this.$route.params.id).then(res => {
        const data = res.response;
        
        this.worker.filial = data.filial
        this.worker.filial_id = data.filial_id
        this.worker.postCodes = data.postCodes

        // Filials
        this.filials.allFilials = this.filials.allFilials.filter(filial => Number(filial.value) !== this.worker.filial_id)
        this.filials.allFilials.unshift({
          value: this.worker.filial_id, 
          label: this.worker.filial, 
          formatLabel: 
          `<div style='font-weight: 500; position: relative;'>
            ${this.worker.filial}
            <span style="position: absolute;bottom: -8px;width: 100%;height: 1px;background: #DFE4EF;left: 0;"></span>
          </div>`,
        })
        this.deposit.selectedFilial = this.filials.allFilials[0]
        this.accountableTransaction.selectedFilial = this.filials.allFilials[0]

        // Posts
        this.posts.allPosts = this.worker.postCodes.map(post => ({
          value: post.post_code,
          label: post.name
        }))

        this.deposit.selectedPost = this.posts.allPosts[0]
        this.accountableTransaction.selectedPost = this.posts.allPosts[0]
      })

      this.workersLocal = [];
      const currentUserId = this.$store.state.userId;

      await this.$store.dispatch("personalEmployee/transactions/fetchWorkersList").then(res => {
        this.workersLocal = this.workersListFromStore.map((item) => ({
          label: item.name,
          value: item.id,
          formatLabel: `
              <div style="display: flex; align-items: center;">
                <div style="width: 34px; height: 34px; border-radius: 50%; background-color: #8e9cbb; margin-right: 10px; overflow: hidden; flex: 0 0 34px">
                  <img src="${item.photo ? item.photo : 'redesign/img/userpic.svg'}" style="width: 100%; height: 100%; object-fit: cover;" />
                </div>
                <div>
                  <div style="">${item.name}</div>
                  <div style="color: #8E9CBB; font-size: 13px;">${item.filial_name}</div>   
                </div>
              </div>
            `,
          isUser: false, 
        }));

      // this.$store.dispatch("personalEmployee/getWorkersList", currentUserId).then((res) => {
      //   console.log('workers', res.response)
      //   res.response.forEach((item) => {
      //     this.workersLocal.push({ value: item.id, label: item.name, isUser: item.is_user });
      //   });

        this.personalAccount.whoContributedItems = [...this.workersLocal];
        this.deposit.whoContributedItems = [...this.workersLocal];
        this.accountableTransaction.whoContributedItems = [...this.workersLocal];

        //console.log(this.$store.state.user, this.$store.state.user.workerPosts, "1111");
        if (this.$store.state.user.workerPosts && this.$store.state.user.workerPosts[0] && this.$store.state.user.workerPosts[0].worker_id) {
          const c = this.workersLocal.findIndex((worker) => Number(worker.value) === Number(this.$store.state.user.workerPosts[0].worker_id));

          if (c !== -1) {
            this.personalAccount.whoContributedLocal = this.workersLocal[c];
            this.deposit.whoContributedLocal = this.workersLocal[c];
            this.accountableTransaction.whoContributedLocal = this.workersLocal[c];
          }
        }
      });

      if (this.type === "personal_account") {
        this.personalAccount.reasonItems = [];
        this.$store.dispatch("personalEmployee/getReasonsListForTransactionPersonalAccountModal").then((res) => {
          this.personalAccount.reasonItems = res.response;
        });
      }

      this.$nextTick(() => {
        if (this.$refs.dateInput1) this.$refs.dateInput1.setCurrentDateInputTypeDate();
        if (this.$refs.dateInput2) this.$refs.dateInput2.setCurrentDateInputTypeDate();
      });
    },

    reset() {
      const currentUserId = this.$store.state.userId;
      let whoContributed = null;
      const c = this.workersLocal.findIndex((worker) => worker.value.toString() === currentUserId.toString());

      if (c !== -1) whoContributed = this.workersLocal[c];

      this.personalAccount = {
        summLocal: "",
        summLocalErrorMessage: "",
        dateEntryLocal: "",
        dateEntryLocalErrorMessage: "",
        whoContributedLocal: whoContributed,
        whoContributedItems: [...this.workersLocal],
        whoContributedLocalErrorMessage: "",
        reasonLocal: null,
        reasonLocalErrorMessage: "",
        reasonItems: [...this.personalAccount.reasonItems],
        newReasonTextLocal: "",
        newReasonTextLocalErrorMessage: "",
        commentLocal: "",
        submitAttempt: false,
      };
      this.deposit = {
        summLocal: "",
        summLocalErrorMessage: "",
        dateEntryLocal: "",
        dateEntryLocalErrorMessage: "",
        whoContributedLocal: whoContributed,
        whoContributedItems: [...this.workersLocal],
        whoContributedLocalErrorMessage: "",
        switcherLocal: false,
        commentLocal: "",
        submitAttempt: false,
      };
      this.accountableTransaction = {
        summLocal: "",
        summLocalErrorMessage: "",
        dateEntryLocal: "",
        dateEntryLocalErrorMessage: "",
        whoContributedLocal: whoContributed,
        whoContributedItems: [...this.workersLocal],
        whoContributedLocalErrorMessage: "",
        switcherLocal: false,
        commentLocal: "",
        submitAttempt: false,
      };
      if (this.$refs.dateInput1) this.$refs.dateInput1.clear();
      if (this.$refs.dateInput2) this.$refs.dateInput2.clear();

      if (this.$refs.textarea2) {
        this.$refs.textarea2.setValue('')
        this.$refs.textarea2.textValue = '';
        this.$refs.textarea2.$refs.textareaValue.innerHTML = '';
      }

      if (this.$refs.comment) {
        this.$refs.comment.setValue('')
        this.$refs.comment.textValue = '';
        this.$refs.comment.$refs.textareaValue.innerHTML = '';
      }
    },

    closeModal() {
      this.localActive = false;
    },

    // setDateEntryLocal (value) {
    //   if (this.type === 'personal_account') {
    //     this.personalAccount.dateEntryLocal = value
    //   } else {
    //     this.deposit.dateEntryLocal = value
    //   }
    // },

    formatAmount(x) {
      if (x > 0) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      }
      if (x < 0) {
        return `- ${(-1 * x).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}`;
      }
      if (!x) x=0;
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },

    submitPersonalAccount() {
      let submitError = false;
      this.personalAccount.submitAttempt = true;

      if (this.personalAccount.summLocal.length === 0) {
        this.personalAccount.summLocalErrorMessage = "Обязательное поле";
        submitError = true;
      }

      if (this.personalAccount.dateEntryLocal.length === 0) {
        this.personalAccount.dateEntryLocalErrorMessage = "Обязательное поле";
        submitError = true;
      }

      // if (this.personalAccount.dateEntryLocal.length < 10) {
      //   this.personalAccount.dateEntryLocalErrorMessage = "Укажите корректное значение";
      //   submitError = true;
      // }

      if (this.personalAccount.whoContributedLocal === null) {
        this.personalAccount.whoContributedLocalErrorMessage = "Обязательное поле";
        submitError = true;
      }

      if (this.personalAccount.reasonLocal === null) {
        this.personalAccount.reasonLocalErrorMessage = "Обязательное поле";
        submitError = true;
      }

      if (
        this.personalAccount.reasonLocal !== null &&
        this.personalAccount.reasonLocal.value === -1 &&
        this.personalAccount.newReasonTextLocal.length === 0
      ) {
        this.personalAccount.newReasonTextLocalErrorMessage = "Обязательное поле";
        submitError = true;
      }

      if (!submitError) {
        this.$emit("submitPersonalAccount", this.switcherLocal, this.personalAccount);
        this.closeModal();
      }
    },

    submitDeposit() {
      let submitError = false;
      this.deposit.submitAttempt = true;

      if (this.deposit.summLocal.length === 0) {
        this.deposit.summLocalErrorMessage = "Обязательное поле";
        submitError = true;
      }

      if (Number(this.deposit.summLocal) === 0) {
        this.deposit.summLocalErrorMessage = "Введите сумму больше нуля";
        submitError = true;
      }

      if (this.deposit.dateEntryLocal.length === 0) {
        this.deposit.dateEntryLocalErrorMessage = "Обязательное поле";
        submitError = true;
      }

      // if (this.deposit.dateEntryLocal.length < 10) {
      //   this.deposit.dateEntryLocalErrorMessage = "Укажите корректное значение";
      //   submitError = true;
      // }

      if (this.deposit.whoContributedLocal === null) {
        this.deposit.whoContributedLocalErrorMessage = "Обязательное поле";
        submitError = true;
      }

      if (!this.deposit.selectedFilial && this.deposit.switcherLocal) {
        this.deposit.selectedFilialErrorMessage = "Обязательное поле";
        submitError = true;
      }

      if (!this.deposit.selectedPost && this.deposit.switcherLocal) {
        this.deposit.selectedPostErrorMessage = "Обязательное поле";
        submitError = true;
      }

      if (!this.deposit.selectedCompany && this.deposit.switcherLocal) {
        this.deposit.selectedCompanyErrorMessage = "Обязательное поле";
        submitError = true;
      }

      if (this.deposit.dateEntryLocalErrorMessage) submitError = true

      if (!submitError) {
        this.$emit("submitDeposit", this.switcherLocal, this.deposit);
        this.closeModal();
      }
    },

    submitAccountableTransaction() {
      let submitError = false;
      this.accountableTransaction.submitAttempt = true;

      if (this.accountableTransaction.summLocal.length === 0) {
        this.accountableTransaction.summLocalErrorMessage = "Обязательное поле";
        submitError = true;
      }

      if (Number(this.accountableTransaction.summLocal) === 0) {
        this.accountableTransaction.summLocalErrorMessage = "Введите сумму больше нуля";
        submitError = true;
      }

      if (this.accountableTransaction.dateEntryLocal.length === 0) {
        this.accountableTransaction.dateEntryLocalErrorMessage = "Обязательное поле";
        submitError = true;
      }

      // if (this.deposit.dateEntryLocal.length < 10) {
      //   this.deposit.dateEntryLocalErrorMessage = "Укажите корректное значение";
      //   submitError = true;
      // }

      // if (this.accountableTransaction.whoContributedLocal === null) {
      //   this.accountableTransaction.whoContributedLocalErrorMessage = "Обязательное поле";
      //   submitError = true;
      // }

      if (!this.accountableTransaction.selectedFilial && this.accountableTransaction.switcherLocal) {
        this.accountableTransaction.selectedFilialErrorMessage = "Обязательное поле";
        submitError = true;
      }

      if (!this.accountableTransaction.selectedPost && this.accountableTransaction.switcherLocal) {
        this.accountableTransaction.selectedPostErrorMessage = "Обязательное поле";
        submitError = true;
      }

      if (!this.accountableTransaction.selectedCompany && this.accountableTransaction.switcherLocal) {
        this.accountableTransaction.selectedCompanyErrorMessage = "Обязательное поле";
        submitError = true;
      }

      if (this.accountableTransaction.dateEntryLocalErrorMessage) submitError = true

      if (!submitError) {
        this.$emit("submitAccountableTransaction", this.switcherLocal, this.accountableTransaction);
        this.closeModal();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/styles/vars.scss";
@import "~@/assets/styles/grid.scss";

.finance-transaction-modal {
  &-close {
    position: absolute;
    top: 12px;
    right: 10px;
  }
  &-title {
    font-weight: 500;
    font-size: 18px;
    line-height: 120%;

    @media screen and (max-width: 700px) {
      font-size: 15px;
    }
  }
  &-switcher {
    margin-top: 20px;
    @media screen and (max-width: 700px) {
      margin-top: 26px;

      ::v-deep & .c-switcher-group {
        width: 100%;
      }
      ::v-deep & .c-switcher-group .c-switcher-group-item {
        width: 50%;
      }
    }
  }

  &-personal-account {
    &-row {
      margin-top: 26px;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;

      @media screen and (max-width: 700px) {
        flex-wrap: wrap;
      }

      &-input {
        // max-width: 100px;
        width: 100%;

        ::v-deep & .c-input .c-input-required {
          bottom: -27px;
        }

        ::v-deep & .c-input .c-input-required svg {
          min-width: 14px;
          min-height: 14px;
        }

        @media screen and (max-width: 700px) {
          ::v-deep & .c-input .c-input-required {
            bottom: -22px;
          }

          max-width: calc(50% - 16px);
        }
      }

      &-date {
        // max-width: 110px;
        width: 100%;

        ::v-deep & .c-input .c-input-required {
          bottom: -32px;
        }

        @media screen and (max-width: 700px) {
          // max-width: calc(50% - 12px);

          ::v-deep & .c-input .c-input-required {
            bottom: -22px;
          }

          ::v-deep & .c-input-container {
            right: 0;
          }
        }

        @media screen and (max-width: 428px) {
          ::v-deep & .c-input .c-input-required {
            bottom: -27px;
          }
        }
      }

      &-select {
        // max-width: 254px;
        width: 100%;

        @media screen and (max-width: 700px) {
          margin-top: 24px;
          max-width: 100%;

          &-mt-50 {
            margin-top: 50px;
          }
        }
      }
    }

    &-reason {
      margin-top: 24px;

      &-mt-50 {
        margin-top: 50px;
      }

      @media screen and (max-width: 700px) {
        margin-top: 24px;
      }

      &-required {
        padding-bottom: 28px;
      }

      &-text {
        margin-top: 25px;

        &-required {
          padding-bottom: 22px;
        }
      }
    }

    &-comment {
      margin-top: 24px;

      @media screen and (max-width: 700px) {
        padding-bottom: 38px;
      }
    }

    &-buttons {
      margin-top: 29px;
      display: flex;
      justify-content: flex-end;

      @media screen and (max-width: 700px) {
        position: fixed;
        bottom: 0;
        right: 0;
        max-width: 100%;
        width: 100%;
      }

      &-cancel {
        background: #ffffff;

        @media screen and (max-width: 700px) {
          border-radius: 0;
          border-bottom: none;
          border-left: none;
          width: 50%;
        }
      }

      &-make {
        margin-left: 10px;
        @media screen and (max-width: 700px) {
          margin-left: 0;
          border-radius: 0;
          // width: 50%;
        }
      }
    }
  }

  &-deposit {
    &-row {
      margin-top: 26px;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;

      @media screen and (max-width: 700px) {
        flex-wrap: wrap;
      }

      &-required {
        padding-bottom: 20px;

        @media screen and (max-width: 700px) {
          padding-bottom: 0;
        }
      }

      &-input {
        // max-width: 100px;
        width: 100%;

        ::v-deep & .c-input .c-input-required {
          bottom: -20px;
        }

        @media screen and (max-width: 700px) {
          // max-width: calc(50% - 16px);

          ::v-deep & .c-input .c-input-required {
            bottom: -22px;
          }
        }
      }

      &-date {
        // max-width: 110px;
        width: 100%;

        ::v-deep & .c-input .c-input-required {
          bottom: -20px;
        }

        @media screen and (max-width: 700px) {
          // max-width: calc(50% - 12px);

          ::v-deep & .c-input .c-input-required {
            bottom: -22px;
          }

          ::v-deep & .c-input-container {
            right: 0;
          }
        }

        @media screen and (max-width: 428px) {
          ::v-deep & .c-input .c-input-required {
            bottom: -27px;
          }
        }
      }

      &-select {
        // max-width: 254px;
        width: 100%;

        @media screen and (max-width: 700px) {
          margin-top: 47px;
          max-width: 100%;
        }
      }
    }

    &-switcher {
      // margin-top: 33px;

      @media screen and (max-width: 700px) {
        // margin-top: 25px;
      }
    }

    &-comment {
      // margin-top: 28px;

      @media screen and (max-width: 700px) {
        // margin-top: 25px;
      }
    }

    &-buttons {
      margin-top: 30px;
      display: flex;
      // justify-content: flex-end;

      @media screen and (max-width: 700px) {
        position: fixed;
        bottom: 0;
        right: 0;
        max-width: 100%;
        width: 100%;
      }

      &-cancel {
        background: #ffffff;

        @media screen and (max-width: 700px) {
          border-radius: 0;
          border-bottom: none;
          border-left: none;
          // width: 50%;
        }
      }

      &-make {
        margin-left: 10px;
        @media screen and (max-width: 700px) {
          margin-left: 0;
          border-radius: 0;
          // width: 50%;
        }
      }
    }
  }
}

::v-deep .modal-custom-size {
  // max-width: 590px;
}

::v-deep .c-input .c-input-required .c-input-required-text {
  white-space: normal !important;
  font-size: 10px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

::v-deep {
  .sidesheet__header {
    flex-basis: unset;
  }
  .sidesheet__wrapper {
    padding-top: 35px;
  }
}

.finance-transaction-modal {
  .col {
    margin-top: 40px;
  }
  &-title {
    font-size: 22px;
  }
}

.finance-transaction-modal-switcher.deposit {
  /deep/ {
    
    .c-switcher-group-item:first-child.c-switcher-group-item_active::after {
      border-color: #12C971;
    }
  }
}

.finance-transaction-modal-deposit-buttons {
  @media (max-width: 767px) {
    button {
      width: 50%;
    }
  }
}

.modal-track {
  width: 100%;
  height: 100%;

  /deep/ {
    .scroll-container {
      padding-right: 0;
    }
  }
}

.modal-frame {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  /deep/ {
    .scroll-container {
      @include vp-767 {
        padding: 0 0 60px;
      }
    }
  }

  .modal-wrapper {
    flex-grow: 1;
    display: flex;
    overflow: hidden;
  }

  .modal-track {
    width: 100%;
    height: 100%;

    /deep/ {
      .scroll-container {
        padding-right: 0;
      }
    }
  }
}

/deep/ {
  .shadow-bottom {
    display: none;
  }
}
</style>
